const formatWord = (str: string, maxCharWord: number, maxWords: number) => {
  const formatted = str && str.replace(/[^\w\s\'\#\$\%\&\/\(\)\=\¡\*\+\-\_\;\|\?\¿\!\"\.\,\@áéíóúüñ]+/gi, '');
  str = formatted && formatted.replace(/\s\s+|\n/g, ' ');
  let isOkMaxLetterInWord = true;
  let arrWords = str.split(/\s/g).filter(Boolean);
  arrWords = getWordsWithRules(arrWords, maxCharWord);
  for (let i=0; i<arrWords.length; i++) {
    if (arrWords[i].length > maxCharWord) {
      isOkMaxLetterInWord = false;
    }
  }
  while (!isOkMaxLetterInWord) {
    isOkMaxLetterInWord = true;
    arrWords = getWordsWithRules(arrWords, maxCharWord);
    for (let i=0; i<arrWords.length; i++) {
      if (arrWords[i].length > maxCharWord) {
        isOkMaxLetterInWord = isOkMaxLetterInWord && false;
      } else {
        isOkMaxLetterInWord = isOkMaxLetterInWord && true;
      }
    }
  }
  if (arrWords.length > maxWords) {
    return arrWords.splice(0, maxWords);
  } else {
    return arrWords;
  }
}

const getWordsWithRules = (words: string[], maxCharWord: number) => {
  let currentString = '';
  for(let i=0; i<words.length; i++){
    if(words[i].length > maxCharWord){
      for(let j=0; j<words[i].length ; j++) {
        if ( (j+1) % maxCharWord === 0) {
          currentString = currentString + words[i][j] + ' ';
        } else {
          currentString = currentString + words[i][j];
        }
      }
    } else {
      currentString = currentString + words[i] + ' ';
    }
  }
  return currentString.split(/\s/g).filter(Boolean);
}

export const normalizeDescription = (maxChardWord: number, maxWords: number) => (value: string, previousValue: string) => {
  let arrValue: string[] = previousValue && previousValue.split(' ');
  let words: string[] = formatWord(value, maxChardWord, maxWords);
  if (words && arrValue && words.length === arrValue.length && arrValue[arrValue.length - 1].length <= maxChardWord && arrValue.length < maxWords) {
    return value.replace(/\s\s+|\n/g, ' ').replace(/[^\w\s\'\#\$\%\&\/\(\)\=\¡\*\+\-\_\;\|\?\¿\!\"\.\,\@áéíóúüñ]+/gi, '');
  }
  return  words.join(' ');
}

export const maxLength = max => value => {
  let currentValue;
  const result = value.length > max;

  if (result === false) {
    currentValue = value;
  }
  return currentValue;
};

export const formatPrice = (price: number) => {
  if (!price) {
    return '00.00';
  }
  return price.toFixed(2);
};
